import { CHANGE_ADDRESS } from '../actions';

export const changeAddress = (address) => ({
  type: CHANGE_ADDRESS,
  payload: { address },
});
